__turbopack_context__.v({
  "checkoutSectionContent": "VJVGoa_checkoutSectionContent",
  "durationToggleGroup": "VJVGoa_durationToggleGroup",
  "itemPrice": "VJVGoa_itemPrice",
  "openSheetButton": "VJVGoa_openSheetButton",
  "participantMenuSelectionListItem": "VJVGoa_participantMenuSelectionListItem",
  "participantRowListItem": "VJVGoa_participantRowListItem",
  "price": "VJVGoa_price",
  "priceBlock": "VJVGoa_priceBlock",
  "sheetLevelsHint": "VJVGoa_sheetLevelsHint",
  "skiAncillaryContent": "VJVGoa_skiAncillaryContent",
  "skiAncillaryLabel": "VJVGoa_skiAncillaryLabel",
  "styledToggleGroup": "VJVGoa_styledToggleGroup",
});
